import { Pipe, PipeTransform } from '@angular/core';
import { ButtonStyle } from '@shared/components/button/model';
import { Color } from '@shared/enums';

@Pipe({
  name: 'getStyle',
  standalone: true,
})
export class GetStylePipe implements PipeTransform {
  transform(style: ButtonStyle): Record<string, string> {
    const result: Record<string, string> = {};
    for (const [key, value] of Object.entries(style)) {
      const color = Color[value as keyof typeof Color];
      if (color) {
        result[key] = color;
      } else {
        result[key] = value as string;
      }
    }
    return result;
  }
}
